import useI18n from '@/hooks/useI18n';
import React from 'react';
import CustomRadioButton from '../CustomRadioButton';
import { FormDataForCreateCampaign } from '@/types/interfaces';
interface CashbackSettingsComponentProps {
  formData: FormDataForCreateCampaign;
}
const CashbackSettingsComponent: React.FC<CashbackSettingsComponentProps> = ({
  formData,
}) => {
  const { t } = useI18n();
  // Function to extract base URL without query parameters
  const getBaseUrl = (url: string): string => {
    try {
      const parsedUrl = new URL(url);
      return `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.pathname}`;
    } catch (error) {
      console.error('Invalid URL:', error);
      return url; // Fallback to original URL if parsing fails
    }
  };
  return (
    <div className="p-4 gap-[20px] flex flex-col">
      <div className="flex gap-4 items-center">
        <div className="w-[32px] h-[32px] bg-[#06B217] text-white rounded-full text-2xl text-center">
          2
        </div>
        <span className="text-[#172B4D] text-base font-semibold">
          {t('common.cashbackSettings')}
        </span>
      </div>
      <div>
        <span className="text-[#9B919D] text-sm font-normal">
          {t('common.campaignBudget')}
        </span>
        <div className="text-[#292828] text-[18px] font-normal">
          {'€'}
          {formData?.budget}
        </div>
      </div>
      <div>
        <span className="text-[#9B919D] text-sm font-normal">
          {t('common.termsConditions')}
        </span>
        <div className="mt-2 ">
          <ol
            className="list-decimal list-outside ml-4 text-[#121111] text-base font-normal  break-all
    max-w-full"
          >
            {formData?.conditions?.map((guideline, index) => (
              <li key={index} className="mb-1">
                <span className="text-[#292828] text-[18px] font-normal">
                  {guideline}
                </span>
              </li>
            ))}
          </ol>
        </div>
      </div>
      <div>
        <span className="text-[#9B919D] text-sm font-normal">
          {t('common.validFor')}
        </span>
        <div className="flex gap-4 mt-2">
          <div className="flex items-center gap-2">
            {formData?.validFor[0] === 'online' && (
              <CustomRadioButton
                name="reachArea"
                value={formData?.validFor[0] === 'online' ? 'online' : ''}
                checked={formData?.validFor[0] === 'online'}
                label={t('common.online')}
                readOnly
                textStyle="text-[#292828] text-lg"
              />
            )}
            {formData?.validFor[0] === 'store' && (
              <CustomRadioButton
                name="reachArea"
                value={formData?.validFor[0] === 'store' ? 'store' : ''}
                checked={formData?.validFor[0] === 'store'}
                label={t('common.store')}
                readOnly
                textStyle="text-[#292828] text-lg"
              />
            )}
            {formData?.validFor[0] === 'both' && (
              <CustomRadioButton
                name="reachArea"
                value={formData?.validFor[0] === 'both' ? 'both' : ''}
                checked={formData?.validFor[0] === 'both'}
                label={'Online/Store'}
                readOnly
                textStyle="text-[#292828] text-lg"
              />
            )}
          </div>
        </div>
      </div>
      <div>
        <span className="text-[#9B919D] text-sm font-normal">
          {t('common.limitPerPerson')}
        </span>
        <div className="text-[#292828] text-lg font-normal">
          {formData?.limitPerPerson}
        </div>
      </div>
      {formData.smartLink && (
        <div>
          <span className="text-[#9B919D] text-sm font-normal">
            {t('common.linkToBeUsed')}
          </span>
          <div className="text-[#292828] text-lg font-normal">
            {formData?.smartLink ? getBaseUrl(formData.smartLink) : ''}
          </div>
        </div>
      )}
    </div>
  );
};

export default CashbackSettingsComponent;
